
export type BannerSize = 
  | 'medium_rectangle' 
  | 'leaderboard' 
  | 'large_rectangle'
  | 'half_page'
  | 'mobile_banner'
  | 'wide_skyscraper'
  | 'small_square'
  | 'square_button'
  | 'vertical_banner'
  | 'billboard'
  | 'portrait'
  | 'small_rectangle';

export interface BannerSizeConfig {
  value: BannerSize;
  name: string;
  width: number;
  height: number;
  description: string;
  label?: string;
}

export const BANNER_SIZES: BannerSizeConfig[] = [
  {
    value: 'medium_rectangle',
    name: 'Medium Rectangle',
    width: 300,
    height: 250,
    description: 'Standard medium-sized banner',
    label: 'Medium Rectangle'
  },
  {
    value: 'leaderboard',
    name: 'Leaderboard',
    width: 728,
    height: 90,
    description: 'Horizontal banner for top of page',
    label: 'Leaderboard'
  },
  {
    value: 'large_rectangle',
    name: 'Large Rectangle',
    width: 336,
    height: 280,
    description: 'Larger rectangular banner',
    label: 'Large Rectangle'
  },
  {
    value: 'half_page',
    name: 'Half Page',
    width: 300,
    height: 600,
    description: 'Tall banner for sidebar',
    label: 'Half Page'
  },
  {
    value: 'mobile_banner',
    name: 'Mobile Banner',
    width: 320,
    height: 50,
    description: 'Small banner for mobile devices',
    label: 'Mobile Banner'
  },
  {
    value: 'wide_skyscraper',
    name: 'Wide Skyscraper',
    width: 160,
    height: 600,
    description: 'Tall, narrow banner for sidebar',
    label: 'Wide Skyscraper'
  },
  {
    value: 'small_square',
    name: 'Small Square',
    width: 200,
    height: 200,
    description: 'Small square banner',
    label: 'Small Square'
  },
  {
    value: 'vertical_banner',
    name: 'Vertical Banner',
    width: 120,
    height: 240,
    description: 'Vertical rectangular banner',
    label: 'Vertical Banner'
  },
  {
    value: 'square_button',
    name: 'Square Button',
    width: 125,
    height: 125,
    description: 'Small square for buttons',
    label: 'Square Button'
  },
  {
    value: 'billboard',
    name: 'Billboard',
    width: 970,
    height: 250,
    description: 'Large horizontal banner',
    label: 'Billboard'
  },
  {
    value: 'portrait',
    name: 'Portrait',
    width: 300,
    height: 1050,
    description: 'Extra tall vertical banner',
    label: 'Portrait'
  },
  {
    value: 'small_rectangle',
    name: 'Small Rectangle',
    width: 180,
    height: 150,
    description: 'Small rectangular banner',
    label: 'Small Rectangle'
  }
];

export interface BannerTextLine {
  text: string;
  fontFamily?: string;
  fontSize?: number;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  position?: {
    x: number;
    y: number;
  };
}

export interface AIIntegration {
  id: string;
  name: string;
  description: string;
  logo?: string;
  isConnected: boolean;
  apiKey?: string;
  lastUsed?: Date;
}

export interface StoredAIIntegration {
  id: string;
  apiKey: string;
  isConnected: boolean;
  lastUsed?: string;
}

export interface Banner {
  id: string;
  name: string;
  size: BannerSize;
  backgroundColor: string;
  textColor: string;
  text: string;
  imageUrl?: string;
  createdAt: Date;
  lastModified?: Date;
  isAIGenerated?: boolean;
  aiProvider?: string;
  type?: string;
  tags?: string[];
  textLines?: BannerTextLine[];
  borderStyle?: string;
  borderWidth?: number;
  borderColor?: string;
  imageSettings?: {
    width: number;
    opacity: number;
    position: { x: number; y: number };
    isAnimated?: boolean;
  };
}
